export default "__VITE_ASSET__9d65734f__"